import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async pesquisarClientes(api, parametros) { 
    parametros.operacao = 'pesquisarClientes';

    let retorno = {};

    await api.santriPOST('/rest/cliente', parametros, 20, false) 
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async pesquisarClientesOrcamento(api, parametros) { 
    parametros.operacao = 'pesquisarClientesOrcamento';

    let retorno = {};

    await api.santriPOST('/rest/cliente', parametros, 20, false) 
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarDadosCompletoCliente(api, parametros) {        
    parametros.operacao = 'buscarDadosCompletoCliente'

    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }, 

  async buscarFinanceirosAberto(api, parametros) {        
    parametros.operacao = 'buscarFinanceirosAberto';

    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  },

  async buscarDadosComplementar(api, parametros) {        
    parametros.operacao = 'buscarDadosComplementar';

    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }, 

  async buscarCarteiraClientes(api, parametros) {        
    parametros.operacao = 'buscarCarteiraClientes'; 

    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }, 

  async verificarCondicaoPagamentoCliente(api, parametros) { 
    parametros.operacao = 'verificarCondicaoPagamentoCliente'

    let retorno = {};

    await api.santriPOST('/rest/cliente', parametros, 20, false) 
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
  async buscarClienteSimplificadoEdicao(api, parametros) {       
    parametros.operacao = 'buscarClienteSimplificadoEdicao';
    let retorno = {};

    await api.santriGET('rest/cliente', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
  async buscarGruposClientes(api, parametros) {       
    parametros.operacao = 'buscarGruposClientes'
    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarTodosGeneros(api) {       
    let parametros = { 
      operacao: 'buscarTodosGeneros'
    }

    let retorno = {};

    await api.santriGET('/rest/cliente', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
   
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCliente/RCliente.js